const img1 = require("@/assets/image/31.png")
const img2 = require("@/assets/image/32.png")
const img3 = require("@/assets/image/33.png")

const classList = [
  {
    id: 1,
    name: "店铺类型",
    content: 
      `<div class="rich_text">
        <div class="name">店铺类型</div>
        <div class="title">1、入驻企业和个人的区别？</div>
        <div class="des">个人店有个人、个体工商户两种店铺类型：个人店：需要上传大陆身份证原件人像面和国徽面照片、并进行实人认证。个体工商户：还需上传属于入驻人本人的个体工商户营业执照。<br />
          企业店有普通店、专营店、专卖店、旗舰店四种店铺类型：普通店：上传三证合一的营业执照（非三证合一的营业执照除营业执照外还需要上传税务登记证、组织机构代码证）。专营店、专卖店、旗舰店：还需上传品牌信息</div>
        <img src="${img1}" alt="">
        <div class="title">2、个体工商户可以开设什么类型的店铺？</div>
        <div class="des">个体工商户只可以开设个体工商户的店铺</div>
      </div>`
  },
  {
    id: 2,
    name: "主营类目",
    content: 
      `<div class="rich_text">
        <div class="name">主营类目</div>
        <div class="title">1、个人店及普通店主营类目的选择</div>
        <div class="des">主营类目有：普通商品、医药健康。</div>
        <div class="des">其中普通商品包括：水果生鲜、美容个护、家居生活、服饰箱包、母婴玩具、食品保健、虚拟商品、运动户外、数码电器、家纺家具家装、汽配摩托。</div>
        <div class="des">入驻后，可以发布除医药健康以外的其他类别商品，但发布依法需要取得特殊经营资质的商品前，应先对应的资质人口上传资质证明文件。</div>
        <div class="title">2、经营的产品类目比较多，入驻时只能选择一个主营类目怎么办？</div>
        <div class="des">如果是经营医药健康，店铺只能经营当前主营类目的商品；其他类目的商品可以同时在一个店铺经营；如果想同时经营普通商品、医药健康，需要换手机号重新入驻。</div>
        <div class="title">3、主营类目选择错误，能对主营类目进行修改吗？</div>
        <div class="des">修改主营类目需满足三个条件：</div>
        <div class="des">1、已缴纳店铺保证金</div>
        <div class="des">2、无任何销售</div>
        <div class="des">3、无商品数据（如有上架，待审核的商品将在确认修改主营类目后全部下架禁售）</div>
        <div class="title">4、一个品牌可以在多个类目开设旗舰店吗？</div>
        <div class="des">一个品牌仅支持开设一个旗舰店。</div>
      </div>`
  },
  {
    id: 3,
    name: "命名规则",
    content: 
      `<div class="rich_text">
        <div class="name">命名规则</div>
        <div class="title">1、店铺命名需要注意什么？</div>
        <div class="des">店铺名称不得与已经通过审核的店铺名称重复。若两个或以上店铺申请相同的符合规定的店铺名称，拼多多依照申请在先原则核定，未通过审核的店铺需要更换店铺名称后重新提交申请。<br />
          未经拼多多许可，店铺名称、店铺标识、店铺详情等均不得使用“拼多多特许”、“拼多多授权”或其他带有类似含义的内容。<br />
          未经相关权利人授权并提交有效证明文件，店铺名称、店铺标识、店铺详情等均不得使用“特约经营”、“特约经销”、“总经销”、“总代理”、“厂家认证”、“官方店铺”或其他可能使买家误认为该店铺已经取得相应品牌授权的内容。<br />
          个人店铺的店铺名称不得使用“旗舰”、“专卖”、“专营”、“官方”、“直营”、“官字”、“官方认证”、“官方授权”、“特许经营”、“特约经销”或其他带有类似含义的内容。<br />
          店铺名称不得带有电话号码、电子邮箱、网址、二维码、即时通讯工具或其他联系信息（如QQ号码、微信号等）。<br />
          店铺名称不得包含具有下列情形的内容：<br />
          (1) 有损国家、社会公共利益，或有损民族尊严的；<br />
          (2) 侵犯他人合法权益的；<br />
          (3) 夸大宣传、可能误导公众的；<br />
          (4) 外国国家或地区的名称；<br />
          (5) 国际组织的名称；<br />
          (6) 政治敏感信息，包括但不限于国家领导人姓名、政党名称、党政军机关名称；<br />
          (7) 含有封建文化糟粕、有消极政治影响，或违背少数民族习俗、带有歧视性的；<br />
          (8) 与经营主体无关，含有除拼多多外的其他电子商务平台信息；<br />
          (9) 其他违反法律法规或社会善良风俗的。</div>
        <div class="title">2、旗舰店、专卖店、专营店怎么命名？</div>
        <div class="des">旗舰店命名格式为：品牌名+类目（选填）+旗舰店<br />
          专卖店命名格式：品牌名+商号+专卖店（当品牌名与商号一致，命名格式：品牌名+类目+专卖店）<br />
          专营店命名格式：商号+类目+专营店<br />
          备注：<br />
          (1) 在选择类目名时，若选择“自定义”，可自行填写类目，若选择“无”，则不显示类目；<br />
          (2) 商号是指用来区分不同企业的关键词，例如：上海欢乐贸易有限公司，商号即为：欢乐；<br />
          (3) 详细命名规则以《拼多多店铺命名规则为准》。</div>
      </div>`
  },
  {
    id: 4,
    name: "资质相关",
    content: 
      `<div class="rich_text">
        <div class="name">资质相关</div>
        <div class="title">1、个人店及普通店主营类目的选择</div>
        <div class="des">个人店：店铺主体是入驻人，同一张入驻人身份证可以开4家个人店（含个体工商户店）；<br />
          企业店：店铺主体是开店公司<br />
          1） 普通企业店：同一个开店公司可以开16家；<br />
          2） 专卖店/专营店/旗舰店同一组企业三证可以开设不同类目的店铺上限由平台根据品牌授权情况动态评估。</div>
        <div class="title">2、怎么区分营业执照是三证合与非三证合一？</div>
        <div class="des">三证合一指您的营业执照右上角写的18位数字为统一社会信用代码，非三证合一指营业执照上右上角写的为注册号。</div>
        <div class="title">3、统一社会信用代码和营业执照注册号怎么填？</div>
        <div class="des">统一社会信用代码是指营业执照右上角以91/93开头的18位代码，在填写统一社会信用代码时，注意区分“0”与“O”、“1”与“I”。营业执照注册号是指营业执照右上角的注册号进行填写即可。建议您在提交前先通过全国企业信用信息公示平台（http://gsxt.saic.gov.cn）按所填写的号码查询以确认号码无误。</div>
        <div class="title">4、三证合一的企业商家如何填写营业执照注册号、组织机构代码、纳税人识别码？</div>
        <div class="des">三证合一的企业在“是否三证合一”处选择“是”，不用填写营业执照注册号、组织机构代码、纳税人识别码，只需要填写社会统一信用代码。</div>
        <div class="title">5、非三证合一的企业商家如何填写统一社会信用代码？</div>
        <div class="des">非三证合一的企业在“是否三证合一”处选择“否”，填写营业执照注册号、组织机构代码、纳税人识别码。</div>
        <div class="title">6、商家入驻时，审核资质不通过，拒绝理由为“该企业被工商局列入异常经营名录”，该怎么办？</div>
        <div class="des">出现该问题时，商家自行到全国企业信用信息公示系统（http://gsxt.saic.gov.cn）查询被列入异常经营名录的原因，然后联系所在地工商部门解决。若企业被工商局列入异常的问题已得到解决，但由于信息的延迟，全国企业信用信息公示系统未做变更，则需要向平台提交所在地工商部门盖章的移出经营异常名录申请表。</div>
        <div class="title">7、为什么商家填写邮箱资料时，提示邮箱不合法？</div>
        <div class="des">如果填写的邮箱地址是qq邮箱，则一定要填写@qq.com字样邮箱，否则可能会出现邮箱不合法的提示，另外如果需要填写多个邮箱资料时，最好填写的是同一个类型的邮箱（例如：都填写qq邮箱）。</div>
        <div class="title">8、企业店铺可以经营多个品牌吗？</div>
        <div class="des">普通企业店铺、专营店可以经营多个品牌；专卖店、旗舰店可以经营多个自有品牌</div>
        <div class="title">9、品牌授权书有固定模板吗？</div>
        <div class="des">旗舰店授权书模板可在填写入驻资料时，品牌资质授权处旁边自行下载<br />
          专营店、专卖店、普通店授权书没有固定模板，授权书中需写明品牌名或商标注册号、被授权方公司全称、加盖品牌方公章<br />
          个人店授权书无固定模板，授权书中需写明品牌名或商标注册号、入驻人姓名和身份证号码/入驻人姓名和店铺ID、加盖品牌方公章<br />
          注：商标为个人所有，授权书需商标权人签名，同时需上传商标权人亲笔签名的身份证复印件</div>
        <div class="title">10、完整的授权指的是什么？</div>
        <div class="des">如商标权人A授权B销售其品牌的商品（视为一级授权），B授权C销售该品牌的商品（视为二级授权），C授权入驻拼多多商家销售该品牌的商品（视为三级授权）。当您为C，在申请入驻拼多多时，那么您需要在入驻时提供A到B的授权文件，以及B到C的授权文件。A-B-C即为完整的授权。</div>
      </div>`
  },
  {
    id: 5,
    name: "保证金",
    content: 
      `<div class="rich_text">
        <div class="name">保证金</div>
        <div class="title">1、入驻平台会收取哪些费用？</div>
        <div class="des">目前不收取任何提点。</div>
        <div class="title">2、店铺保证金在什么时候缴纳？</div>
        <div class="des">入驻及发布产品时均不需要支付保证金，但在缴存足额店铺保证金之前，您的店铺将受到一定的限制，包括提现、报名活动、发布商品货值及库存限额等。在您想要发布超过货值或库存限额的商品，或者想要提现、报名活动时，需要先支付足额的店铺保证金。</div>
        <div class="title">3、各类目店铺保证金的标准是多少？</div>
        <div class="des">您好，商家应当缴存1000元基础店铺保证金。<br />
          店铺发布特定商品的，除缴存基础店铺保证金外，还应缴存特殊店铺保证金。具体保证金规则您可使用账号登陆商家后台。</div>
        <div class="title">4、店铺保证金会调整吗？</div>
        <div class="des">平台有权每月根据店铺上个自然月的成交金额，按照下表所列标准对其基础店铺保证金进行调整。若店铺账户内的基础店铺保证金余额高于其上个自然月成交金额所对应的基础店铺保证金标准的，则店铺保证金不予调整。</div>
        <img src="${img2}" alt="">
        <div class="des">平台有权每月根据店铺上个自然月的成交金额，对一级分类“电动车/配件/交通工具”下二级分类“电动车零/配件”下三级分类“电动车电池”下的店铺，按照下表所列标准调整其特殊店铺保证金。商家应按照调整后的特殊店铺保证金标准及时补缴差额部分。</div>
        <img src="${img3}" alt="">
        <div class="des">具体保证金规则您可使用账号登陆商家后台</div>
        <div class="title">5、店铺保证金以后可以退吗?</div>
        <div class="des">商家退出平台时，店铺保证金会在退店后退还给商家。</div>
        <div class="title">6、保证金缴纳完了，平台提供相关凭证吗?</div>
        <div class="des">商家成功入驻开店后，平台会在商家管理后台提供电子版保证金收据，商家可自行打印。</div>
        <div class="title">7、提现需要多久?</div>
        <div class="des">提现一般是2-4个工作日到账。</div>
        <div class="title">8、提现账户名绑定要求?</div>
        <div class="des">企业店铺必须绑定企业对公账户或企业法定代表人个人银行账户；个人店铺必须绑定店铺入驻人个人银行账户。账户名绑定成功后不可修改。</div>
      </div>`
  },
  {
    id: 6,
    name: "店铺后台",
    content: 
      `<div class="rich_text">
        <div class="name">店铺后台</div>
        <div class="title">1、商家所售产品是否一定要设置包邮？</div>
        <div class="des">商家可以按照实际情况自由选择包邮省份，不包邮的省份可以自行设置运费模板。</div>
        <div class="title">2、商家货款是怎么结算的？</div>
        <div class="des">消费者购买商品且拼单后，打款至平台，之后商家发货，等消费者在平台确认收货后，该款项会自动结算至商家可提现余额，之后商家方可向平台申请提现。常规商品默认消费者收货时间为15天，境外直邮商品为30天，若消费者点击延迟确认收货则默认再延后3天收货。</div>
      </div>`
  },
  {
    id: 7,
    name: "售后问题",
    content: 
      `<div class="rich_text">
        <div class="name">售后问题</div>
        <div class="title">1、产生的订单发货时间有要求？</div>
        <div class="des">常规商品48小时内安排发货，境外直供商品在168小时内发货（7天），境外直邮商品在120小时内发货（5天），预售商品在预售规定时间内发货（如：2月19日预售，该预售商品需要在2月19日全部发完）。</div>
        <div class="title">2、出现售后问题，商家该怎么处理？</div>
        <div class="des">如因商品出现售后问题，商家需要与消费者积极沟通协商处理，如需商家做出售后处理，则依据实际情况可协商选择给消费者部分退款或者全额退款。</div>
        <div class="title">3、关于退款，退回路径，何时到账？</div>
        <div class="des">后台会在48小时内审核消费者退款，因付款的第三方支付平台不同，退款到账时间会有差异：<br />
          (1) 支付宝余额或者微信零钱支付，退款会在审核后24小时内到账(节假日会有稍微顺延)；<br />
          (2) 通过支付宝或者微信使用的银行卡支付，退款会在审核后2-6个工作日到账；<br />
          (3) 使用信用卡支付，退款会在审核后3-7个工作日到账。</div>
      </div>`
  },
  {
    id: 8,
    name: "其他",
    content: 
      `<div class="rich_text">
        <div class="name">其他</div>
        <div class="title">1、在信悦臻选平台开店是否需要费用？</div>
        <div class="des">目前不收取任何提点。</div>
        <div class="title">2、店铺审核时效是多久</div>
        <div class="des">个人店：两个工作日（周末、节假日顺延）<br />
          个体户/普通店/专营店/专卖店/旗舰店：三个工作日（周末、节假日顺延）<br />
          无论是否通过审核，注册手机都会收到平台发送的信息。</div>
        <div class="title">3、个人店入驻人姓名、身份证号填写错误怎么办？</div>
        <div class="des">请联系客服</div>
      </div>`
  },
]

export {
  classList
}